import cachedFirestore from "../cachedFirestore";
import { getLogger } from "../logging";
import { showErrorSnackbar } from "../snackbar";
import store from "../store";

const log = getLogger("Community");

export async function storeFavorite(levelId) {
  if (store.levelsFavorited.size >= 30) {
    showErrorSnackbar("You can only favorite up to 30 levels.");
    return false;
  }
  store.set("levelsFavorited", store.levelsFavorited.add(levelId));
  submitLevelFavoriteData(true, levelId);
  return true;
}

export async function removeFavorite(levelId) {
  const success = store.levelsFavorited.delete(levelId);
  if (!success)
    log.warn(`Failed to delete level ${levelId} from favorites`);
  store.save("levelsFavorited");
  submitLevelFavoriteData(false, levelId);
}

const submitLevelFavoriteData = async (favorite, levelId) => {
  await cachedFirestore.setDocument({
    reference: `communityLevels/${levelId}/player/${store.user.uid}`,
    data: {
      favorite,
    },
  });
};
